
import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";
import BottomSheetModal from "./BottomSheetModal";
import { Colors } from "colors";
import { Svg as SvgIcon } from "assets/svg";
import Input from "./Input";
import AsyncStorage from "@react-native-async-storage/async-storage";   
import VText from "./VText";
import { useLocalSearchParams } from "expo-router";
import { FlatList } from "react-native";
import { showToast } from "utils/ToastUtils";
import { getCountry, setCountry, setCurrency, setCountries } from "appRedux/reducers/storedUtilsSlice";
import { useRouter } from "expo-router";
import { updateUserProfile, getUserDetails } from "appRedux/reducers/profileSlice";


export default React.forwardRef((props, ref) => {
    const { height, width } = useWindowDimensions();
    const dispatch = useDispatch();
    const _bottomSheetRef = useRef();    
    const country = useSelector((state) => state.StoredutilsSlice.country);
    const currency = useSelector((state) => state.StoredutilsSlice.currency);
    const userProfile = useSelector((state) => state.ProfileReducer.profileData);
    const router = useRouter();
    const local = useLocalSearchParams();
    const localGender = local?.gender || "female";
    React.useImperativeHandle(ref, () => ({ show }), []);
    const [currencyData, setCurrencyData] = useState([]);

    const show = () => {
        _bottomSheetRef?.current?.show();
    };
    useEffect(() => {

        if(country){
            setCurrencyData(country.currency);
        }
    }, [country]);

    const handleCurrencyChange =  async (item) => {
        dispatch(setCurrency(item));
        _bottomSheetRef?.current?.hide();
        
        if(userProfile?.userId){
            let payload = {
                userId: userProfile?.userId,
                name: userProfile?.name,
                gender: userProfile?.gender,
                lastUsedCountry:country.name,
                lastUsedCurrency:item
            }
            await dispatch(updateUserProfile(payload));
            await dispatch(getUserDetails());
        }
        AsyncStorage.setItem("IPisChanged", "false");
        showToast("Location changed to "+ country.name);
        window.location.reload();


    }


 
    
    const _renderItem = ({ item, index }) => {
        return (
            <TouchableOpacity onPress={() => {  
                handleCurrencyChange(item);
            }}>
                <View style={{...styles.item}}>
                    <VText style={{...styles.itemText,fontWeight:currency === item ? "bold" : "normal" }}>{item}</VText>
                </View>
            </TouchableOpacity>
        );
    };

    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                // onPress={() => _bottomSheetRef?.current?.hide()}
            >
                <TouchableOpacity
                    style={{
                        width: wp(375),
                        minHeight: hp(100),
                        backgroundColor: "white",
                        paddingTop: spV(20),
                        paddingBottom: spV(15),
                        paddingHorizontal: spH(20),
                        overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <View style={{ }}>
                        <View style={styles.header}>
                            <VText style={styles.headingText}>Currency</VText>
                            {/* <TouchableOpacity onPress={() => _bottomSheetRef?.current?.hide()}>
                                    <Image accessibilityLabel="Close Icon" source={SvgIcon.closeIcon} style={styles.closeIcon} />
                               </TouchableOpacity> */}
                        </View>
                        <FlatList
                            style={{marginTop: spV(10),height:hp(100)}}
                            data={currencyData}
                            renderItem={_renderItem}
                            keyExtractor={(item, index) => index.toString()}
                        />
                    </View>
                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        borderRadius: 8,
        width: wp(309),
    },
    header: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: spV(15),
    },
    headingText: {
        fontSize: fp(20),
        fontWeight: "650",
    },
    closeIcon: {
        width: wp(20),
        height: hp(20),
    },
    item: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "start",
        gap: spH(10),
        paddingVertical: spV(14),
        borderBottomWidth: 1,
        borderBottomColor: "#0000001A",
    },
    itemImage: {
        width: wp(20),
        height: hp(20),
        borderRadius: 100,
        
    },
    itemText: {
        fontSize: fp(14),
        fontWeight: "400",
        marginTop: spH(5),
    },
    searchIcon: {
        width: wp(20),
        height: hp(20),
        marginRight:spH(10)
    },
});
